import { useState, useEffect, useMemo, useCallback } from 'react';
import { DgtPdOrderPicklist } from '../models'
import { getDates } from '../utilities/Format'
import { PicklistStatus } from '../constants/EnumType'
import { 
  getPDCheckedOrderPicklists,
  getQACheckedOrderPicklists,
  getHeaderPicklist
} from '../states/PicklistAction'

export default function useQaCheckOrderPicklist(
  status: string,
  dateFrom: Date,
  dateTo: Date,
  searchByOrder: string,
  division: string
) : DgtPdOrderPicklist[] {
  const [picklists, setPicklists] = useState<DgtPdOrderPicklist[]>([]);

  const fetchSinglePicklist = useCallback(async () => {
    const picklistHeader = await getHeaderPicklist(searchByOrder)
    if (picklistHeader) {
      setPicklists([ ...picklists, picklistHeader ])
    }
  }, [ searchByOrder, picklists ])

  useEffect(() => {
    const periodDates = getDates(dateFrom, dateTo)
    // sorted date LIFO (Last In First Out)
    periodDates.sort((d1, d2) => d2.localeCompare(d1))
    
    Promise.allSettled(periodDates.map(date => {
      if (status === PicklistStatus.PD_CHECKED) {
        return getPDCheckedOrderPicklists(date, division, 'Mixing')
      } else if (status === PicklistStatus.QA_CHECKED) {
        return getQACheckedOrderPicklists(date, division, true)
      }
      return Promise.reject(`Picklist Status not supported : ${status}`)
    })).then(results => {
      const totalPicklists = (results
        .filter(res => res.status === 'fulfilled') as PromiseFulfilledResult<DgtPdOrderPicklist[]>[])
        .reduce((prev, cur) => [...prev, ...cur.value], [] as DgtPdOrderPicklist[])
      setPicklists(totalPicklists)
    })
    .catch(err => console.error(err))
  }, [ status, dateFrom, dateTo, division ]);

  const filteredPicklists = useMemo(() => picklists.filter(pl => pl.pk.includes(searchByOrder)), [ searchByOrder, picklists ])

  if (filteredPicklists.length === 0 && searchByOrder.length === 8) fetchSinglePicklist()

  return filteredPicklists
}